<div class="container-fluid mt-4">


    <!-- Row -->
    <div class="row">

        <div class="col-lg-12 d-flex justify-content-between align-items-center">
            <div class="col-md-10 mb-3">
                <h5 class="font-medium m-0">Audit Status</h5>
            </div>
            <div class="col-md-2 mb-2">
                <!-- <a [routerLink]="'/audit/assigned-audit/' + iSocietyDetailsId" class="font-medium m-0 underline"
                    style="font-size: large; text-decoration: underline;">
                    Back to List</a> -->
                <a [routerLink]="'/dashboard'" class="font-medium m-0 underline"
                    style="font-size: large; text-decoration: underline;">
                    Back to List
                </a>

            </div>
        </div>


        <div class="row">
            <div class="col-lg-5">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="row mb-3">
                                <!-- Upload Report -->
                                <div class="col-md-5">
                                    <input type="hidden" class="form-control" [(ngModel)]="newUpload.transId"
                                        name="transId" disabled>

                                    <label for="UploadReport" class="form-label">Upload Report</label>
                                    <input class="form-control" type="file" id="UploadReport"
                                        (change)="onFileChange($event)" [(ngModel)]="newUpload.documentPath"
                                        #documentPath="ngModel" [disabled]="!isFormSubmitted">

                                    <div *ngIf="documentPath.touched && !newUpload.documentPath" class="text-danger">
                                        Please upload a report.
                                    </div>
                                </div>

                                <!-- Select Status -->
                                <div class="col-md-5">
                                    <label for="status" class="form-label">Select Status</label>
                                    <select [(ngModel)]="newUpload.status" class="form-control" name="status"
                                        id="status" #statusAudit="ngModel" [disabled]="!isFormSubmitted">
                                        <option value="" disabled>Select Status</option>
                                        <option value="MoveForward">Move Forward</option>
                                        <option value="InSendBack">Send Back</option>
                                    </select>

                                    <div *ngIf="statusAudit.touched && !newUpload.status" class="text-danger">
                                        Please select a status.
                                    </div>
                                </div>

                                <!-- Download Button -->
                                <div class="col-md-2 d-flex align-items-end" *ngIf="showDownload && uploadedFilePath">
                                    <label class="form-label d-none">Download</label>
                                    <!-- <a [href]="uploadedFilePath"  download class="btn btn-outline-primary">
                                        <i class="bi bi-download">

                                        </i>
                                    </a> --> <button class="btn btn-primary btn-sm" (click)="downloadDocument(uploadedFilePath)">
                                        <i class="fa fa-download" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>

                            <div class="col-lg-12 mb-3">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" [(ngModel)]="newUpload.isChecked"
                                        id="DisclaimerAudit" [disabled]="!isFormSubmitted"
                                        style="transform: scale(1.2); accent-color: black; font-weight: bold;">
                                    <label class="form-check-label" for="DisclaimerAudit">
                                        <strong>Disclaimer:</strong> Before marking the report as prepared, read this
                                        carefully and check
                                        the box if you agree. If you tick the disclaimer, it means you have checked all
                                        the records carefully.
                                    </label>
                                </div>
                            </div>

                            <div class="col-lg-12 mb-3 text-end">
                                <button type="button" (click)="UpdateStatus(iSocietyDetailsId)"
                                    class="btn btn-primary btn-sm" [disabled]="!StatusFormValid()"
                                    *ngIf="isUpdateVisible">Update</button>
                            </div>


                            <div class="col-lg-12">
                                <div class="card">
                                    <div class="card-body">
                                        <div class="step-progressbar">
                                            <div class="v-progress">
                                                <ul>
                                                    <li *ngFor="let process of lstAuditProcess"
                                                        class="{{ process.status }}">
                                                        {{ process.statusname }} <br>
                                                        <small style="font-size: 12px;">{{ process.dCreateDate |
                                                            date:'dd/MM/yyyy' }}</small>

                                                    </li>
                                                </ul>

                                            </div>
                                        </div>
                                        <p class="mt-2 mb-0 fs-14px text-danger">Once you submitted the checklist and
                                            report go to verification section and download the checklist and attached it
                                            in the manual report before submitting the report manually. If you don't
                                            attached the checklist, manual report will not be submitted in the depar</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-7">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h5 class="m-0">Checklist</h5>
                        </div>

                        <div class="accordion" id="accordianAuditReports">
                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne"
                                        (click)="loadAuditors(iSocietyDetailsId)">
                                        Society Information
                                    </button>
                                </h2>
                                <div id="collapseOne" class="accordion-collapse collapse show"
                                    data-bs-parent="#accordianAuditReports">
                                    <div class="accordion-body">

                                        <div class="row align-items-end">
                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Name</label>
                                                <input type="text" class="form-control"
                                                    [value]="filteredData[0].sSocietyName" placeholder="Enter Name"
                                                    disabled>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Registration No</label>
                                                <input type="text" class="form-control"
                                                    [value]="filteredData[0].sSocietyRegistrationNo"
                                                    placeholder="Enter Registration Number" disabled>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Registration Date</label>
                                                <input type="text" class="form-control"
                                                    [value]="filteredData[0].dFinishApplicationdate | date:'dd/MM/yyyy'"
                                                    placeholder="Enter Registration date" disabled>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Address</label>
                                                <input type="text" class="form-control"
                                                    [value]="filteredData[0].address" placeholder="Enter Name" disabled>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Level</label>
                                                <input type="text" class="form-control" [value]="filteredData[0].level"
                                                    placeholder="Enter Level" disabled>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Sector</label>
                                                <input type="text" class="form-control"
                                                    [value]="filteredData[0].society" placeholder="Enter Society"
                                                    disabled>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Type</label>
                                                <input type="text" class="form-control" [value]="filteredData[0].type"
                                                    placeholder="Enter Type" disabled>
                                            </div>
                                            <div class="col-md-6 mb-2">
                                                <input type="hidden" class="form-control"
                                                    [value]="filteredData[0].iSocietyTransID" placeholder="Enter Type"
                                                    disabled hidden>
                                            </div>

                                            <div class="row">
                                                <input type="hidden" class="form-control"
                                                    [value]="building.iSocietyTransID" placeholder="Enter Type" disabled
                                                    hidden>
                                                <!-- Society Building -->
                                                <div class="row">

                                                    <div class="col-md-4 mb-2">
                                                        <label class="form-label">Society Building <span
                                                                class="text-danger">*</span></label>
                                                        <select class="form-control"
                                                            [(ngModel)]="building.societyBuilding" id="statusSocieties"
                                                            name="statusSocieties" #statusSocieties="ngModel" required
                                                            [disabled]="isReadOnly">

                                                            <option [ngValue]="0" disabled>Select Building</option>
                                                            <option [ngValue]="true">Yes</option>
                                                            <option [ngValue]="false">No</option>
                                                        </select>

                                                        <div *ngIf="building.societyBuilding == null && formSubmitted"
                                                            class="text-danger">
                                                            Society Building is required.
                                                        </div>
                                                    </div>


                                                    <!-- Type of Building (Shown only if Society Building is true) -->
                                                    <div class="col-md-4 mb-2"
                                                        *ngIf="building.societyBuilding === true">
                                                        <label class="form-label">Type of Building <span
                                                                class="text-danger">*</span></label>
                                                        <select class="form-control" [(ngModel)]="building.buildingType"
                                                            [disabled]="isReadOnly" id="buildingType"
                                                            name="buildingType" #buildingType="ngModel" required
                                                            [disabled]="isReadOnly">
                                                            <option value="" disabled>Select Building</option>
                                                            <option value="Own Building">Own Building</option>
                                                            <option value="Rented">Rented</option>
                                                            <option value="Rent Free">Rent Free</option>
                                                            <option value="Leased Building">Leased Building</option>
                                                            <option value="BUILDING PROVIDED BY THE GOVT">BUILDING
                                                                PROVIDED BY THE GOVT</option>
                                                        </select>
                                                        <div *ngIf="formSubmitted && !building.buildingType"
                                                            class="text-danger">
                                                            Type of Building is required.
                                                        </div>
                                                    </div>

                                                    <!-- Remarks -->
                                                    <div class="col-md-4 mb-2"
                                                        *ngIf="building.societyBuilding === true">
                                                        <label class="form-label">Remarks <span
                                                                class="text-danger">*</span></label>
                                                        <input type="text" class="form-control"
                                                            [(ngModel)]="building.sRemarks" placeholder="Enter Remark"
                                                            minlength="3" maxlength="200" [disabled]="isReadOnly"
                                                            required>
                                                        <div *ngIf="formSubmitted && !building.sRemarks"
                                                            class="text-danger">
                                                            Remarks are required.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row">
                                                <!-- Land Details -->
                                                <div class="col-md-4 mb-2">
                                                    <label class="form-label">Land Details <span
                                                            class="text-danger">*</span></label>
                                                    <select class="form-control" [(ngModel)]="building.landDetails"
                                                        id="landDetails" name="landDetails" #landDetails="ngModel"
                                                        required [disabled]="isReadOnly">
                                                        <option [ngValue]="''" disabled>Select Land</option>
                                                        <option [ngValue]="true">Yes</option>
                                                        <option [ngValue]="false">No</option>
                                                    </select>

                                                    <div *ngIf="formSubmitted && building.landDetails === null"
                                                        class="text-danger">
                                                        Land Details are required.
                                                    </div>
                                                </div>

                                                <!-- Type of Possession (Shown only if Land Details is true) -->
                                                <div class="col-md-4 mb-2" *ngIf="building.landDetails  === true">
                                                    <label class="form-label">Type of Possession <span
                                                            class="text-danger">*</span></label>
                                                    <select class="form-control" [(ngModel)]="building.possessionType"
                                                        [disabled]="isReadOnly" id="possessionType"
                                                        name="possessionType" #possessionType="ngModel" required
                                                        [disabled]="isReadOnly">
                                                        <option value="" selected>Type of Possession</option>
                                                        <option value="Owned/ leased/land allotted by govt.">Owned/
                                                            leased/land allotted by govt.</option>
                                                    </select>
                                                    <div *ngIf="formSubmitted && !building.possessionType"
                                                        class="text-danger">
                                                        Type of Possession is required.
                                                    </div>
                                                </div>

                                                <!-- Area (Shown only if Land Details is true) -->
                                                <div class="col-md-4 mb-2" *ngIf="building.landDetails === true">
                                                    <label class="form-label">If Yes, Enter Area <sup>(In Acres)</sup>
                                                        <span class="text-danger">*</span></label>
                                                    <input type="number" class="form-control"
                                                        [(ngModel)]="building.sArea" [disabled]="isReadOnly"
                                                        placeholder="Enter Area" min="1" max="9999" required
                                                        #areaControl="ngModel" (keypress)="validateNumber($event)">

                                                    <div *ngIf="areaControl.touched && areaControl.invalid"
                                                        class="text-danger">
                                                        <div *ngIf="areaControl.errors?.['required']">Area is required.
                                                        </div>
                                                        <div *ngIf="areaControl.errors?.['min']">Area must be at least
                                                            1.</div>
                                                        <div *ngIf="areaControl.errors?.['max']">Area cannot be more
                                                            than 9999</div>
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="col-md-12 mb-2 text-end">
                                                <button type="button" class="btn btn-primary"
                                                    [style.display]="hasSubmittedRemark ? 'none' : 'inline-block'"
                                                    [disabled]="!BuildingformIsValid() "
                                                    (click)="submitBuildingForm(); NextButton(currentToggleId1)">Save
                                                    And Continue</button>
                                            </div>

                                        </div>



                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                        Basic Common Parameters
                                    </button>
                                </h2>
                                <div id="collapseTwo" class="accordion-collapse collapse"
                                    data-bs-parent="#accordianAuditReports">
                                    <div class="accordion-body">

                                        <div class="row align-items-end">

                                            <!-- Status of Societies -->
                                            <div class="col-md-6 mb-2">
                                                <input type="hidden" class="form-control"
                                                    [(ngModel)]="newSociety.transId" name="newSociety.transId"
                                                    placeholder="Enter Type" disabled hidden>
                                                <label class="form-label">Status of Societies <span
                                                        class="text-danger">*</span></label>
                                                <select class="form-control" [(ngModel)]="newSociety.statusSocieties"
                                                    [disabled]="isReadOnly" id="statusSocieties" name="statusSocieties"
                                                    #statusSocieties="ngModel" required>
                                                    <option value="" selected>Select Status</option>
                                                    <option *ngFor="let sta of status" [value]="sta.id">{{
                                                        sta.name }}</option>
                                                </select>
                                                <div *ngIf="statusSocieties.invalid && statusSocieties.touched"
                                                    class="text-danger">
                                                    Status is required.
                                                </div>
                                            </div>

                                            <!-- For Cooperative Bank -->
                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">For Cooperative Bank <span
                                                        class="text-danger">*</span></label>

                                                <select class="form-control" [(ngModel)]="newSociety.isCorporativeBank"
                                                    id="isCorporativeBank" required #isCorporativeBank="ngModel"
                                                    [disabled]="isReadOnly">
                                                    <option [ngValue]="0" disabled>Select Cooperative Bank</option>
                                                    <option [ngValue]="true">Yes</option>
                                                    <option [ngValue]="false">No</option>
                                                </select>

                                                <div *ngIf="isCorporativeBank.invalid && isCorporativeBank.touched"
                                                    class="text-danger">
                                                    This field is required.
                                                </div>
                                            </div>

                                            <!-- Show only if "Yes" is selected -->
                                            <div class="col-md-6 mb-2" *ngIf="newSociety.isCorporativeBank === true">
                                                <label class="form-label">Cooperative Bank Branches <span
                                                        class="text-danger">*</span></label>
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="newSociety.cooperativeBankBranches"
                                                    [disabled]="isReadOnly" placeholder="No. of Branches"
                                                    name="cooperativeBankBranches" id="cooperativeBankBranches" required
                                                    #cooperativeBankBranches="ngModel" min="1" max="9999"
                                                    (keypress)="validateNumber($event)">

                                                <!-- Validation Messages -->
                                                <div *ngIf="cooperativeBankBranches.invalid && cooperativeBankBranches.touched"
                                                    class="text-danger">
                                                    <div *ngIf="cooperativeBankBranches.errors?.['required']">This field
                                                        is required.</div>
                                                    <div *ngIf="cooperativeBankBranches.errors?.['min']">Branches must
                                                        be at least 1.</div>
                                                    <div *ngIf="cooperativeBankBranches.errors?.['max']">Branches cannot
                                                        be more than 9999.</div>
                                                </div>
                                            </div>

                                            <div class="col-md-12">
                                                <p class="fs-14px m-0">Number of members for Secondary and Apex
                                                    Institute Societies</p>
                                            </div>

                                            <!-- Show inputs only if the society is Apex or Secondary -->
                                            <div *ngIf="apexSociety">
                                                <div class="row">
                                                    <!-- Cooperative Societies -->
                                                    <div class="col-md-6 mb-2">
                                                        <label class="form-label">Cooperative Societies <span
                                                                class="text-danger">*</span></label>
                                                        <input type="number" class="form-control"
                                                            [(ngModel)]="newSociety.noOfMember" [disabled]="isReadOnly"
                                                            placeholder="Enter Cooperative Societies" name="noOfMember"
                                                            id="noOfMember" required #noOfMember="ngModel" min="1"
                                                            max="9999" (keypress)="validateNumber($event)">

                                                        <div *ngIf="noOfMember.invalid && noOfMember.touched"
                                                            class="text-danger">
                                                            <div *ngIf="noOfMember.errors?.['required']">This field is
                                                                required and must be a number.</div>
                                                            <div *ngIf="noOfMember.errors?.['min']">Cooperative must be
                                                                at
                                                                least 1.</div>
                                                            <div *ngIf="noOfMember.errors?.['max']">Cooperative cannot
                                                                be
                                                                more than 9999.</div>
                                                        </div>
                                                    </div>

                                                    <!-- Individuals -->
                                                    <div class="col-md-6 mb-2">
                                                        <label class="form-label">Individuals <span
                                                                class="text-danger">*</span></label>
                                                        <input type="number" class="form-control"
                                                            [(ngModel)]="newSociety.apexInstituteSociety"
                                                            [disabled]="isReadOnly" placeholder="Enter Individuals"
                                                            name="apexInstituteSociety" id="apexInstituteSociety"
                                                            required #apexInstituteSociety="ngModel" min="1" max="9999"
                                                            (keypress)="validateNumber($event)">

                                                        <div *ngIf="apexInstituteSociety.invalid && apexInstituteSociety.touched"
                                                            class="text-danger">
                                                            This field is required.
                                                            <div *ngIf="apexInstituteSociety.errors?.['min']">
                                                                Individuals
                                                                must be at least 1.</div>
                                                            <div *ngIf="apexInstituteSociety.errors?.['max']">
                                                                Individuals
                                                                cannot be more than 9999.</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                            <!-- No. of Members for Primary Societies -->
                                            <div class="col-md-12">
                                                <p class="fs-14px m-0">Number of members for Primary Societies</p>
                                            </div>
                                            <div *ngIf="primarySociety">
                                                <div class="row">
                                                    <!-- Gender -->
                                                    <div class="col-md-6 mb-2">
                                                        <label class="form-label">Gender <span
                                                                class="text-danger">*</span></label>
                                                        <select class="form-control" [(ngModel)]="newSociety.gender"
                                                            [disabled]="isReadOnly" id="gender" name="gender" required
                                                            #genderdata="ngModel">
                                                            <option value="" selected>Select Gender</option>
                                                            <option *ngFor="let gen of gender" [value]="gen.id">{{
                                                                gen.name }}</option>
                                                        </select>

                                                        <!-- Validation Messages -->
                                                        <div *ngIf="genderdata.invalid && genderdata.touched"
                                                            class="text-danger">
                                                            <div *ngIf="genderdata.errors?.['required']">Gender is
                                                                required.</div>
                                                        </div>
                                                    </div>

                                                    <!-- Total Member -->
                                                    <div class="col-md-6 mb-2">
                                                        <label class="form-label">Total Member <span
                                                                class="text-danger">*</span></label>

                                                        <input type="number" class="form-control"
                                                            [(ngModel)]="newSociety.membercount" [disabled]="isReadOnly"
                                                            placeholder="Enter member count" name="membercount"
                                                            id="membercount" #totalMember="ngModel" min="1" max="9999"
                                                            (keypress)="validateNumber($event)">
                                                        <!-- Validation Messages -->
                                                        <div *ngIf="totalMember.invalid && totalMember.touched"
                                                            class="text-danger">
                                                            <div *ngIf="totalMember.errors?.['required']">Total Members
                                                                is
                                                                required.</div>
                                                            <div *ngIf="totalMember.errors?.['min']">Members must be at
                                                                least
                                                                1.</div>
                                                            <div *ngIf="totalMember.errors?.['max']">Members cannot be
                                                                more
                                                                than 9999.</div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Managing Committee Details -->
                                            <div class="col-md-12">
                                                <p class="fs-14px m-0">Managing Committee Details</p>
                                            </div>

                                            <!-- No. of Members -->
                                            <div class="col-md-4 mb-2">
                                                <label class="form-label">No. of Members <span
                                                        class="text-danger">*</span></label>
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="newSociety.memberCommitee" placeholder="No. of Members"
                                                    [disabled]="isReadOnly" name="memberCommitee" required
                                                    #memberCommitee="ngModel" min="1" max="9999"
                                                    (keypress)="validateNumber($event)">

                                                <!-- Validation Messages -->
                                                <div *ngIf="memberCommitee.invalid && memberCommitee.touched"
                                                    class="text-danger">
                                                    <div *ngIf="memberCommitee.errors?.['required']">No. of Members is
                                                        required.</div>
                                                    <div *ngIf="memberCommitee.errors?.['min']">Members must be at least
                                                        1.</div>
                                                    <div *ngIf="memberCommitee.errors?.['max']">Members cannot be more
                                                        than 9999.</div>
                                                </div>
                                            </div>

                                            <!-- Elected Member -->
                                            <div class="col-md-4 mb-2">
                                                <label class="form-label">Elected Member <span
                                                        class="text-danger">*</span></label>
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="newSociety.electedMember" placeholder="Elected Member"
                                                    [disabled]="isReadOnly" name="electedMember" required
                                                    #electedMember="ngModel" min="1" max="9999"
                                                    (keypress)="validateNumber($event)">

                                                <!-- Validation Messages -->
                                                <div *ngIf="electedMember.invalid && electedMember.touched"
                                                    class="text-danger">
                                                    <div *ngIf="electedMember.errors?.['required']">Elected Member is
                                                        required.</div>
                                                    <div *ngIf="electedMember.errors?.['min']">Elected Member must be at
                                                        least 1.</div>
                                                    <div *ngIf="electedMember.errors?.['max']">Elected Members cannot be
                                                        more than 9999.</div>
                                                </div>
                                            </div>

                                            <!-- Vacant (if any) -->
                                            <div class="col-md-4 mb-2">
                                                <label class="form-label">Vacant (if any)</label>
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="newSociety.vacantMember" placeholder="Vacant"
                                                    [disabled]="isReadOnly" name="vacantMember" #vacantMember="ngModel"
                                                    min="1" max="9999" (keypress)="validateNumber($event)">

                                                <!-- Validation Messages -->
                                                <div *ngIf="vacantMember.invalid && vacantMember.touched"
                                                    class="text-danger">
                                                    <div *ngIf="vacantMember.errors?.['min']">Vacant must be at least 1.
                                                    </div>
                                                    <div *ngIf="vacantMember.errors?.['max']">Vacant cannot be more than
                                                        9999.</div>
                                                </div>
                                            </div>


                                            <!-- Employee Details -->
                                            <div class="col-lg-12">
                                                <h5 class="m-0">Employee Details</h5>
                                            </div>

                                            <!-- Trained Employees -->
                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Trained Employees <span
                                                        class="text-danger">*</span></label>
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="newSociety.trainedEmp" [disabled]="isReadOnly"
                                                    placeholder="Trained Employees" name="trainedEmp" id="trainedEmp"
                                                    required #trainedEmp="ngModel" min="1" max="9999"
                                                    (keypress)="validateNumber($event)">
                                                <div *ngIf="trainedEmp.invalid && trainedEmp.touched"
                                                    class="text-danger">
                                                    <div *ngIf="trainedEmp.errors?.['required']">Trained Employees
                                                        required</div>
                                                    <div *ngIf="trainedEmp.errors?.['min']">Trained Employees must be at
                                                        least 1.</div>
                                                    <div *ngIf="trainedEmp.errors?.['max']">Trained Employees cannot be
                                                        more than 9999</div>

                                                </div>
                                            </div>

                                            <!-- Untrained Employees -->
                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Untrained Employees <span
                                                        class="text-danger">*</span></label>
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="newSociety.unTrainedEmp" [disabled]="isReadOnly"
                                                    placeholder="Untrained Employees" name="unTrainedEmp"
                                                    id="unTrainedEmp" required #unTrainedEmp="ngModel" min="1"
                                                    max="9999" (keypress)="validateNumber($event)">
                                                <div *ngIf="unTrainedEmp.invalid && unTrainedEmp.touched"
                                                    class="text-danger">
                                                    <div *ngIf="unTrainedEmp.errors?.['required']">Untrained Employees
                                                        required</div>
                                                    <div *ngIf="unTrainedEmp.errors?.['min']">Untrained Employees must
                                                        be at least 1.</div>
                                                    <div *ngIf="unTrainedEmp.errors?.['max']">Untrained Employees cannot
                                                        be more than 9999</div>
                                                </div>
                                            </div>

                                            <!-- Full Time Secretaries (Paid) -->
                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Full Time Secretaries (Paid)</label>
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="newSociety.fullTimeSC" [disabled]="isReadOnly"
                                                    placeholder="Eneter Full Time Secretaries" required
                                                    #fullTimeSC="ngModel" min="1" max="9999"
                                                    (keypress)="validateNumber($event)">
                                                <div *ngIf="fullTimeSC.invalid && fullTimeSC.touched"
                                                    class="text-danger">
                                                    <div *ngIf="fullTimeSC.errors?.['required']">Full Time Secretaries
                                                        required</div>
                                                    <div *ngIf="fullTimeSC.errors?.['min']">Full Time Secretaries must
                                                        be at least 1.</div>
                                                    <div *ngIf="fullTimeSC.errors?.['max']">Full Time Secretaries cannot
                                                        be more than 9999</div>
                                                </div>
                                            </div>

                                            <!-- Part Time Secretaries (Paid) -->
                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Part Time Secretaries (Paid)</label>
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="newSociety.partTimeSC"
                                                    placeholder="Enter Part Time Secretaries" [disabled]="isReadOnly"
                                                    required #partTimeSC="ngModel" min="1" max="9999"
                                                    (keypress)="validateNumber($event)">
                                                <div *ngIf="partTimeSC.invalid && partTimeSC.touched"
                                                    class="text-danger">
                                                    <div *ngIf="partTimeSC.errors?.['required']">Part Time Secretaries
                                                        required</div>
                                                    <div *ngIf="partTimeSC.errors?.['min']">Part Time Secretaries must
                                                        be at least 1.</div>
                                                    <div *ngIf="partTimeSC.errors?.['max']">Part Time Secretaries cannot
                                                        be more than 9999</div>
                                                </div>
                                            </div>

                                            <!-- Employee Table -->
                                            <div class="col-md-12">
                                                <div class="card">
                                                    <div class="card-body">
                                                        <div class="row align-items-end">
                                                            <form #auditorForm="ngForm"
                                                                (ngSubmit)="submitAuditorForm(auditorForm)">
                                                                <div class="row">
                                                                    <div class="col-md-4 mb-3">
                                                                        <input type="hidden" class="form-control"
                                                                            [(ngModel)]="newEMP.transId" name="transId">

                                                                        <select class="form-control"
                                                                            [(ngModel)]="newEMP.sSocietyEmpTypes"
                                                                            id="sSocietyEmpType" name="sSocietyEmpType"
                                                                            required #sSocietyEmpTypes="ngModel"
                                                                            [disabled]="isReadOnly">
                                                                            <option value="" selected>Select Employees
                                                                            </option>
                                                                            <option *ngFor="let emp of FatchedData"
                                                                                [value]="emp.name">{{ emp.name }}
                                                                            </option>
                                                                        </select>
                                                                        <div *ngIf="sSocietyEmpTypes.invalid && sSocietyEmpTypes.touched"
                                                                            class="text-danger">
                                                                            Employee type is required!
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-md-4 mb-3">
                                                                        <input type="number" class="form-control"
                                                                            [(ngModel)]="newEMP.noOfEmployee"
                                                                            placeholder="Numbers" name="noOfEmployee"
                                                                            id="noOfEmployee" required
                                                                            [disabled]="isReadOnly"
                                                                            #noOfEmployee="ngModel" min="1" max="9999"
                                                                            (keypress)="validateNumber($event)">
                                                                        <div *ngIf="noOfEmployee.invalid && noOfEmployee.touched"
                                                                            class="text-danger">

                                                                            <div
                                                                                *ngIf="noOfEmployee.errors?.['required']">
                                                                                Employee No. is required!</div>
                                                                            <div *ngIf="noOfEmployee.errors?.['min']">
                                                                                Employee No. must
                                                                                be at least 1.</div>
                                                                            <div *ngIf="noOfEmployee.errors?.['max']">
                                                                                Employee No. cannot
                                                                                be more than 9999</div>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-md-4 mb-3 text-end">
                                                                        <input type="submit"
                                                                            [style.display]="hasSubmittedRemark ? 'none' : 'inline-block'"
                                                                            class="btn btn-outline-primary btn-sm"
                                                                            value="Add">
                                                                    </div>
                                                                </div>
                                                            </form>

                                                        </div>

                                                        <ngx-datatable
                                                            class="ngx-datatable billdata colored-header sm table-striped table-hover"
                                                            [rows]="Empdatas" [columns]="columns" [columnMode]="'force'"
                                                            [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
                                                            [externalPaging]="false" (page)="setPage(iSocietyDetailsId)"
                                                            [virtualization]="false" [scrollbarV]="false"
                                                            [scrollbarH]="true" [loadingIndicator]="loading">

                                                            <!-- S.No. Column -->
                                                            <ngx-datatable-column name="#" [sortable]="false">
                                                                <ng-template let-rowIndex="rowIndex"
                                                                    ngx-datatable-cell-template>
                                                                    <span>{{ (page.pageNumber) * page.pageSize +
                                                                        rowIndex + 1 }}</span>
                                                                </ng-template>
                                                            </ngx-datatable-column>

                                                            <!-- Dynamic Columns -->
                                                            <ngx-datatable-column *ngFor="let column of columns"
                                                                [sortable]="true" [name]="column.name"
                                                                [prop]="column.prop">
                                                                <ng-template ngx-datatable-cell-template
                                                                    let-value="value">
                                                                    {{ value }}
                                                                </ng-template>
                                                            </ngx-datatable-column>

                                                            <!-- Action Column -->
                                                            <ngx-datatable-column name="Action" [sortable]="false">
                                                                <ng-template let-row="row" ngx-datatable-cell-template>
                                                                    <button type="button" class="btn btn-danger btn-sm"
                                                                        (click)="openDeleteModal(row.iTSocietyEmpID, 0, 0, 'Employee')"
                                                                        data-bs-toggle="modal"
                                                                        data-bs-target="#exampleModalCenter"
                                                                        [disabled]="isDeleteDisabled">
                                                                        <i class="bi bi-trash3"></i>
                                                                    </button>
                                                                </ng-template>
                                                            </ngx-datatable-column>

                                                        </ngx-datatable>



                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Submit Button -->
                                            <div class="col-md-12 mt-3 text-end">
                                                <button type="button" class="btn btn-primary"
                                                    [disabled]="!formIsValid()"
                                                    [style.display]="hasSubmittedRemark ? 'none' : 'inline-block'"
                                                    (click)="submitCommanSocietyForm(); NextButton(currentToggleId2)">Save
                                                    And Continue</button>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseThree" aria-expanded="false"
                                        aria-controls="collapseThree">
                                        Business Turnover of Services
                                    </button>
                                </h2>
                                <div id="collapseThree" class="accordion-collapse collapse"
                                    data-bs-parent="#accordianAuditReports">
                                    <div class="accordion-body">

                                        <div class="row align-items-end">
                                            <div class="row align-items-end">
                                                <div class="col-lg-6" *ngFor="let service of lstBussinessUpgrades">
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="checkbox"
                                                            [(ngModel)]="service.checked"
                                                            (change)="updateSelectedServices(service.id)"
                                                            [disabled]="isReadOnly" (change)="onCheckboxChange()">
                                                        <label class="form-check-label">
                                                            {{ service.name }}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <form #checklistForm="ngForm" (ngSubmit)="submitChecklistValue();NextButton(currentToggleId3)"
                                                novalidate>
                                                <div class="row">
                                                    <div class="col-lg-12">
                                                        <!-- Hidden Input for Transaction ID -->
                                                        <input type="hidden" class="form-control"
                                                            [(ngModel)]="newchecked.transId" name="transId">

                                                        <ng-container *ngFor="let ser of lstBussinessUpgrades">
                                                            <ng-container *ngIf="ser.checked">
                                                                <div>
                                                                    <h6 class="mt-3">{{ ser.name }}</h6>
                                                                    <div class="row">
                                                                        <div class="col-6 mb-2"
                                                                            *ngFor="let selectedSer of ser.lstServiceData">
                                                                            <div class="mb-3">
                                                                                <label class="form-label">
                                                                                    {{ selectedSer.fieldName }}
                                                                                </label>
                                                                                <span class="text-danger"
                                                                                    *ngIf="selectedSer.isRequired">*</span>

                                                                                <!-- Boolean Type: Show Select Dropdown -->
                                                                                <ng-container
                                                                                    *ngIf="selectedSer.dataType === 'boolean'; else textInput">
                                                                                    <select class="form-control"
                                                                                        [(ngModel)]="selectedSer.value"
                                                                                        [required]="selectedSer.isRequired"
                                                                                        [disabled]="isReadOnly || hasSubmittedRemark"
                                                                                        name="{{ selectedSer.fieldName }}"
                                                                                        #selectedSerInput="ngModel">
                                                                                        <option [ngValue]="true">Yes
                                                                                        </option>
                                                                                        <option [ngValue]="false">No
                                                                                        </option>
                                                                                    </select>

                                                                                    <!-- Validation Message for Select -->
                                                                                    <div *ngIf="selectedSer.isRequired && selectedSerInput.invalid && selectedSerInput.touched"
                                                                                        class="text-danger">
                                                                                        {{ selectedSer.fieldName }} is
                                                                                        required.
                                                                                    </div>
                                                                                </ng-container>

                                                                                <!-- Other Data Types: Show Text Input -->
                                                                                <ng-template #textInput>
                                                                                    <input class="form-control"
                                                                                        [(ngModel)]="selectedSer.value"
                                                                                        [type]="selectedSer.dataType"
                                                                                        [required]="selectedSer.isRequired"
                                                                                        [disabled]="isReadOnly || hasSubmittedRemark"
                                                                                        placeholder="Enter the Value"
                                                                                        maxlength="20"
                                                                                        name="{{ selectedSer.fieldName }}"
                                                                                        #selectedSerInput="ngModel" />

                                                                                    <!-- Validation Message for Input -->
                                                                                    <div *ngIf="selectedSer.isRequired && selectedSerInput.invalid && selectedSerInput.touched"
                                                                                        class="text-danger">
                                                                                        {{ selectedSer.fieldName }} is
                                                                                        required.
                                                                                    </div>
                                                                                </ng-template>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </ng-container>
                                                        </ng-container>
                                                    </div>
                                                </div>

                                                <!-- Show error message if the form is invalid and submitted -->
                                                <div *ngIf="!formsturnIsValid" class="text-danger">
                                                    Please fill all required fields before submitting.
                                                </div>

                                                <div class="col-12 text-end">
                                                    <button type="submit" class="btn btn-primary"
                                                        [style.display]="hasSubmittedRemark ? 'none' : 'inline-block'"
                                                        [disabled]="!isAnyCheckboxChecked || !formsturnIsValid">
                                                        Save And Continue
                                                    </button>
                                                </div>
                                            </form>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseFour" aria-expanded="false"
                                        aria-controls="collapseFour">
                                        Common Audit Parameters
                                    </button>
                                </h2>
                                <div id="collapseFour" class="accordion-collapse collapse"
                                    data-bs-parent="#accordianAuditReports">
                                    <div class="accordion-body">

                                        <div class="row align-items-end">
                                            <input type="hidden" class="form-control"
                                                [(ngModel)]="commanPerameter.transId" name="transId"
                                                placeholder="Enter Type" disabled hidden>
                                            <!-- <div class="col-md-6 mb-2">
                                                <label class="form-label">Audit Year<span
                                                        class="text-danger">*</span></label>
                                                <input type="number" class="form-control" name="sAuditYear"
                                                    [disabled]="isReadOnly" placeholder="Enter Audit Year (e.g., 2022)"
                                                     [(ngModel)]="commanPerameter.sAuditYear" required
                                                    #auditYearControl="ngModel" (keypress)="validateNumber($event)"
                                                    min="1900" [max]="currentYear + 5" pattern="^[0-9]{4}$"
                                                    minlength="4" maxlength="4"> -->

                                            <!-- Validation Messages -->
                                            <!-- <div *ngIf="auditYearControl.invalid && auditYearControl.touched"
                                                    class="text-danger">
                                                    <div *ngIf="auditYearControl.errors?.['required']">Audit Year is
                                                        required.</div>
                                                    <div *ngIf="auditYearControl.errors?.['pattern']">Enter a valid
                                                        4-digit year (e.g., 2022).</div>
                                                    <div *ngIf="auditYearControl.errors?.['min']">Year cannot be before
                                                        1900.</div>
                                                    <div *ngIf="auditYearControl.errors?.['max']">Year cannot be beyond
                                                        {{ currentYear + 5 }}.</div>
                                                </div> 
                                            </div> -->
                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Audit Year <span
                                                        class="text-danger">*</span></label>
                                                <select class="form-control" name="sAuditYear" [disabled]="isReadOnly"
                                                    [(ngModel)]="commanPerameter.sAuditYear" required
                                                    #auditYearControl="ngModel">
                                                    <option value="0" disabled>Select Year</option>

                                                    <option *ngFor="let year of yearOptions" [value]="year">{{ year }}
                                                    </option>
                                                </select>

                                                <!-- Validation Messages -->
                                                <div *ngIf="auditYearControl.invalid && auditYearControl.touched"
                                                    class="text-danger">
                                                    <div *ngIf="auditYearControl.errors?.['required']">Audit Year is
                                                        required.</div>
                                                </div>
                                            </div>


                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Audit Classification<span
                                                        class="text-danger">*</span></label>
                                                <input type="text" class="form-control" name="sAuditClassification"
                                                    [disabled]="isReadOnly" placeholder="Enter Audit Classification"
                                                    placeholder="Enter Audit Classification"
                                                    [(ngModel)]="commanPerameter.sAuditClassification" required
                                                    #sAuditClassificationControl="ngModel" minlength="3" maxlength="50">
                                                <div *ngIf="sAuditClassificationControl.touched && !commanPerameter.sAuditClassification"
                                                    class="text-danger">
                                                    Audit Classification is required.
                                                </div>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Name of Auditor<span
                                                        class="text-danger">*</span></label>
                                                <input type="text" class="form-control" name="sAuditorName"
                                                    [disabled]="isReadOnly" placeholder="Enter Name of Auditor"
                                                    [(ngModel)]="commanPerameter.sAuditorName" required
                                                    #sAuditorNameControl="ngModel" minlength="3" maxlength="20">
                                                <div *ngIf="sAuditorNameControl.touched && !commanPerameter.sAuditorName"
                                                    class="text-danger">
                                                    Auditor Name is required.
                                                </div>
                                            </div>
                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Date of Audit Allotment<span
                                                        class="text-danger">*</span></label>




                                                <!-- Show Date Picker When Editing/Inserting Data -->
                                                <input *ngIf="isEditing" type="date" class="form-control"
                                                    name="dAuditAllotmentDate" [disabled]="isReadOnly"
                                                    [(ngModel)]="commanPerameter.dAuditAllotmentDate">

                                                <!-- Show Read-Only Text When Viewing Data -->
                                                <input *ngIf="!isEditing" type="text" class="form-control"
                                                    name="dAuditAllotmentDate" [disabled]="true"
                                                    [(ngModel)]="commanPerameter.dAuditAllotmentDate">

                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Audit Start Date<span
                                                        class="text-danger">*</span></label>
                                                <input *ngIf="isEditing" type="date" class="form-control"
                                                    name="dAuditStartDate" [disabled]="isReadOnly"
                                                    [(ngModel)]="commanPerameter.dAuditStartDate" required
                                                    #dAuditStartDateControl="ngModel">
                                                <!-- Show Date Picker When Editing/Inserting Data -->


                                                <!-- Show Read-Only Text When Viewing Data -->
                                                <input *ngIf="!isEditing" type="text" class="form-control"
                                                    name="dAuditStartDate" [disabled]="true"
                                                    [(ngModel)]="commanPerameter.dAuditStartDate">



                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Submission Date<span
                                                        class="text-danger">*</span></label>
                                                <input *ngIf="isEditing" type="date" class="form-control"
                                                    name="dSubmitDate" [disabled]="isReadOnly"
                                                    [(ngModel)]="commanPerameter.dSubmitDate" required
                                                    #dSubmitDateControl="ngModel">





                                                <!-- Show Read-Only Text When Viewing Data -->
                                                <input *ngIf="!isEditing" type="text" class="form-control"
                                                    name="dSubmitDate" [disabled]="true"
                                                    [(ngModel)]="commanPerameter.dSubmitDate">


                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Date of General House Meeting<span
                                                        class="text-danger">*</span></label>
                                                <input *ngIf="isEditing" type="date" class="form-control"
                                                    name="dGeneralHouseMeeting" [disabled]="isReadOnly"
                                                    [(ngModel)]="commanPerameter.dGeneralHouseMeeting" required
                                                    #dGeneralHouseMeetingControl="ngModel">
                                                <!-- Show Read-Only Text When Viewing Data -->
                                                <input *ngIf="!isEditing" type="text" class="form-control"
                                                    name="dGeneralHouseMeeting" [disabled]="true"
                                                    [(ngModel)]="commanPerameter.dGeneralHouseMeeting">

                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Date of Election<span
                                                        class="text-danger">*</span></label>
                                                <input *ngIf="isEditing" type="date" class="form-control"
                                                    name="dDateOfElection" [disabled]="isReadOnly"
                                                    [(ngModel)]="commanPerameter.dDateOfElection" required
                                                    #dDateOfElectionControl="ngModel">
                                                <input *ngIf="!isEditing" type="text" class="form-control"
                                                    name="dDateOfElection" [disabled]="true"
                                                    [(ngModel)]="commanPerameter.dDateOfElection">


                                            </div>
                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Income<span
                                                        class="text-danger">*</span></label>
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="commanPerameter.sIncome" name="sIncome" id=""
                                                    placeholder="Enter Income" required #incomeControl="ngModel"
                                                    [disabled]="isReadOnly" min="1" max="999999999"
                                                    (keypress)="validateNumber($event)">
                                                <div *ngIf="incomeControl.touched && !commanPerameter.sIncome"
                                                    class="text-danger">

                                                    <div *ngIf="incomeControl.errors?.['required']"> Income is required.
                                                    </div>
                                                    <div *ngIf="incomeControl.errors?.['min']">Income must be at least
                                                        1.
                                                    </div>
                                                    <div *ngIf="incomeControl.errors?.['max']">Income cannot be more
                                                        than
                                                        9,999,999,99.</div>
                                                </div>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Expenditure<span
                                                        class="text-danger">*</span></label>
                                                <input type="text" class="form-control"
                                                    [(ngModel)]="commanPerameter.sExpenditure" name="sExpenditure"
                                                    [disabled]="isReadOnly" id="" placeholder="Enter Expenditure"
                                                    required #expenditureControl="ngModel" minlength="3" maxlength="20">
                                                <div *ngIf="expenditureControl.touched && !commanPerameter.sExpenditure"
                                                    class="text-danger">
                                                    Expenditure is required.
                                                </div>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Profit<span
                                                        class="text-danger">*</span></label>
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="commanPerameter.sProfit" name="sProfit" id=""
                                                    placeholder="Enter Profit" required #profitControl="ngModel"
                                                    [disabled]="isReadOnly" min="0" max="9999999"
                                                    (keypress)="validateNumber($event)">
                                                <div *ngIf="profitControl.touched && !commanPerameter.sProfit"
                                                    class="text-danger">

                                                    <div *ngIf="profitControl.errors?.['required']">Profit is required.
                                                    </div>

                                                    <div *ngIf="profitControl.errors?.['max']">Profit cannot be more
                                                        than
                                                        9,999,999.</div>
                                                </div>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Loss<span class="text-danger">*</span></label>
                                                <input type="number" class="form-control"
                                                    [(ngModel)]="commanPerameter.sLoss" name="sLoss" id=""
                                                    placeholder="Enter Loss" required #lossControl="ngModel"
                                                    [disabled]="isReadOnly" min="0" max="9999999"
                                                    (keypress)="validateNumber($event)">
                                                <div *ngIf="lossControl.touched && !commanPerameter.sLoss"
                                                    class="text-danger">
                                                    <div *ngIf="lossControl.errors?.['required']">loss is required.
                                                    </div>

                                                    <div *ngIf="lossControl.errors?.['max']">loss cannot be more than
                                                        9,999,999.</div>
                                                </div>
                                            </div>
                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">GST No</label>
                                                <input type="text" class="form-control" [disabled]="isReadOnly"
                                                    [(ngModel)]="commanPerameter.sGSTNO" name="sGSTNO"
                                                    placeholder="Enter GST No" #gstNoControl="ngModel"
                                                    pattern="^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$"
                                                    minlength="15" maxlength="15" required>
                                                <div *ngIf="gstNoControl.touched && gstNoControl.invalid"
                                                    class="text-danger">
                                                    <div *ngIf="gstNoControl.errors?.['required']">GST No. is required.
                                                    </div>
                                                    <div *ngIf="gstNoControl.errors?.['pattern']">Invalid GST No format.
                                                    </div>
                                                    <div
                                                        *ngIf="gstNoControl.errors?.['minlength'] || gstNoControl.errors?.['maxlength']">
                                                        GST No must be exactly 15 characters long.
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">PAN No<span
                                                        class="text-danger">*</span></label>
                                                <input type="text" class="form-control" [disabled]="isReadOnly"
                                                    [(ngModel)]="commanPerameter.sPANNo" name="sPANNo"
                                                    placeholder="Enter PAN No" required #panNoControl="ngModel"
                                                    pattern="^[A-Z]{5}[0-9]{4}[A-Z]{1}$" minlength="10" maxlength="10">
                                                <div *ngIf="panNoControl.touched && panNoControl.invalid"
                                                    class="text-danger">
                                                    <div *ngIf="panNoControl.errors?.['required']">PAN No is required.
                                                    </div>
                                                    <div *ngIf="panNoControl.errors?.['pattern']">Invalid PAN No format.
                                                    </div>
                                                    <div
                                                        *ngIf="panNoControl.errors?.['minlength'] || panNoControl.errors?.['maxlength']">
                                                        PAN No must be exactly 10 characters long.
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">TAN No</label>
                                                <input type="text" class="form-control" [disabled]="isReadOnly"
                                                    [(ngModel)]="commanPerameter.sTanNo" name="sTanNo"
                                                    placeholder="Enter TAN No" #tanNoControl="ngModel"
                                                    pattern="^[A-Z]{4}[0-9]{5}[A-Z]{1}$" minlength="10" maxlength="10">
                                                <div *ngIf="tanNoControl.touched && tanNoControl.invalid"
                                                    class="text-danger">
                                                    <div *ngIf="tanNoControl.errors?.['required']">TAN No is required.
                                                    </div>
                                                    <div *ngIf="tanNoControl.errors?.['pattern']">Invalid TAN No format.
                                                    </div>
                                                    <div
                                                        *ngIf="tanNoControl.errors?.['minlength'] || tanNoControl.errors?.['maxlength']">
                                                        TAN No must be exactly 10 characters long.
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">EPF No<span
                                                        class="text-danger">*</span></label>
                                                <input type="text" class="form-control" [disabled]="isReadOnly"
                                                    [(ngModel)]="commanPerameter.sEPFNo" name="sEPFNo"
                                                    placeholder="Enter EPF No" required #epfNoControl="ngModel"
                                                    minlength="5" maxlength="25">
                                                <div *ngIf="epfNoControl.touched && epfNoControl.invalid"
                                                    class="text-danger">
                                                    <div *ngIf="epfNoControl.errors?.['required']">EPF No is required.
                                                    </div>
                                                    <div *ngIf="epfNoControl.errors?.['minlength']">EPF No must be at
                                                        least 5 characters long.</div>
                                                    <div *ngIf="epfNoControl.errors?.['maxlength']">EPF No cannot exceed
                                                        15 characters.</div>
                                                </div>
                                            </div>


                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Special Report</label>
                                                <select class="form-control" [disabled]="isReadOnly"
                                                    [(ngModel)]="commanPerameter.isSpecialReport" name="isSpecialReport"
                                                    id="">
                                                    <option>{{ commanPerameter.isSpecialReport }}</option>
                                                </select>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Working Capital<span
                                                        class="text-danger">*</span></label>
                                                <input type="number" class="form-control" [disabled]="isReadOnly"
                                                    [(ngModel)]="commanPerameter.sWorkingCapital" name="sWorkingCapital"
                                                    id="" placeholder="Enter Working Capital" required
                                                    #workingCapitalControl="ngModel" min="1" max="99999999"
                                                    (keypress)="validateNumber($event)">
                                                <div *ngIf="workingCapitalControl.touched && !commanPerameter.sWorkingCapital"
                                                    class="text-danger">

                                                    <div *ngIf="workingCapitalControl.errors?.['required']">Working
                                                        Capital is required.</div>
                                                    <div *ngIf="workingCapitalControl.errors?.['min']">Working Capital
                                                        must be at least 1.</div>
                                                    <div *ngIf="workingCapitalControl.errors?.['max']">Working Capital
                                                        cannot be more than 9,999,999.</div>
                                                </div>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Audit Fee<span
                                                        class="text-danger">*</span></label>
                                                <input type="number" class="form-control" [disabled]="isReadOnly"
                                                    [(ngModel)]="commanPerameter.sAuditFee" name="sAuditFee" id=""
                                                    placeholder="Enter Audit Fee" required #auditFeeControl="ngModel"
                                                    min="1" max="999999999" (keypress)="validateNumber($event)">
                                                <div *ngIf="auditFeeControl.touched && !commanPerameter.sAuditFee"
                                                    class="text-danger">
                                                    <div *ngIf="auditFeeControl.errors?.['required']">
                                                        Audit Fees is required.</div>
                                                    <div *ngIf="auditFeeControl.errors?.['min']">Audit Fees
                                                        must be at least 1.</div>
                                                    <div *ngIf="auditFeeControl.errors?.['max']">Audit Fees
                                                        cannot be more than 9,999,999.</div>

                                                </div>
                                            </div>

                                            <div class="col-md-12">
                                                <h6 class="mt-2 text-medium">Misappropriation/ Embezzlement</h6>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Amount Involved<span
                                                        class="text-danger">*</span></label>
                                                <input type="number" class="form-control" [disabled]="isReadOnly"
                                                    [(ngModel)]="commanPerameter.sAmountInvolved" name="sAmountInvolved"
                                                    id="" placeholder="Enter Amount Involved" required
                                                    #amountInvolvedControl="ngModel" min="1" max="9999999"
                                                    (keypress)="validateNumber($event)">
                                                <div *ngIf="amountInvolvedControl.touched && !commanPerameter.sAmountInvolved"
                                                    class="text-danger">

                                                    <div *ngIf="amountInvolvedControl.errors?.['required']">
                                                        Amount Involved is required.</div>
                                                    <div *ngIf="amountInvolvedControl.errors?.['min']"> Amount Involved
                                                        must be at least 1.</div>
                                                    <div *ngIf="amountInvolvedControl.errors?.['max']"> Amount Involved
                                                        cannot be more than 9,999,999.</div>

                                                </div>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Date of Detection<span
                                                        class="text-danger">*</span></label>
                                                <input *ngIf="isEditing" type="date" class="form-control"
                                                    [disabled]="isReadOnly"
                                                    [(ngModel)]="commanPerameter.sDateOfDetection"
                                                    name="sDateOfDetection" id="" placeholder="Enter Date of Detection"
                                                    required #dateOfDetectionControl="ngModel">
                                                <input *ngIf="!isEditing" type="text" class="form-control"
                                                    name="sDateOfDetection" [disabled]="true"
                                                    [(ngModel)]="commanPerameter.sDateOfDetection">

                                            </div>
                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Total Share Capital <span
                                                        class="text-danger">*</span></label>
                                                <input type="number" [(ngModel)]="commanPerameter.totalshare"
                                                    class="form-control" #totalShare="ngModel" required min="1"
                                                    max="99999999" [disabled]="isReadOnly"
                                                    placeholder="Enter total share capital"
                                                    (keypress)="validateNumber($event)">
                                                <div *ngIf="totalShare.invalid && totalShare.touched"
                                                    class="text-danger">
                                                    <div *ngIf="totalShare.errors?.['required']">
                                                        Total Share Capital is required and must be a valid number.
                                                    </div>
                                                    <div *ngIf="totalShare.errors?.['min']">Total Share Capital
                                                        must be at least 1.</div>
                                                    <div *ngIf="totalShare.errors?.['max']">Total Share Capital
                                                        cannot be more than 9,999,999.</div>

                                                </div>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Members <span
                                                        class="text-danger">*</span></label>
                                                <input type="number" [(ngModel)]="commanPerameter.member"
                                                    class="form-control" #member="ngModel" required min="1"
                                                    max="9999999" placeholder="Enter members"
                                                    (keypress)="validateNumber($event)" [disabled]="isReadOnly">
                                                <div *ngIf="member.invalid && member.touched" class="text-danger">
                                                    <div *ngIf="member.errors?.['required']">
                                                        Members count is required and must be a valid number.
                                                    </div>
                                                    <div *ngIf="member.errors?.['min']">Members count
                                                        must be at least 1.</div>
                                                    <div *ngIf="member.errors?.['max']"> Members count
                                                        cannot be more than 9,999,999.</div>

                                                </div>
                                            </div>

                                            <div class="col-md-12 mb-2">
                                                <label class="form-label">Have Any Govt. Share <span
                                                        class="text-danger">*</span></label>
                                                <select class="form-control" [(ngModel)]="commanPerameter.govtshares"
                                                    id="govtshares" name="govtshares" #statusSocieties="ngModel"
                                                    required [disabled]="isReadOnly">

                                                    <option [ngValue]="null" disabled>Select Govt. Share</option>
                                                    <option [ngValue]="true">Yes</option>
                                                    <option [ngValue]="false">No</option>
                                                </select>

                                                <div *ngIf="commanPerameter.govtshares == null && formSubmitted"
                                                    class="text-danger">
                                                    Govt. Share is required.
                                                </div>
                                            </div>

                                            <!-- All other fields wrapped inside this div, which will only show if 'Yes' is selected -->
                                            <div *ngIf="commanPerameter.govtshares === true">
                                                <div class="row">
                                                    <div class="col-md-6 mb-2">
                                                        <label class="form-label">Govt Share <span
                                                                class="text-danger">*</span></label>
                                                        <input type="number" [(ngModel)]="commanPerameter.govtShare"
                                                            class="form-control" #govtShare="ngModel" required min="1"
                                                            max="9999999" placeholder="Enter Govt. share"
                                                            [disabled]="isReadOnly" (keypress)="validateNumber($event)">
                                                        <div *ngIf="govtShare.invalid && govtShare.touched"
                                                            class="text-danger">
                                                            <div *ngIf="govtShare.errors?.['required']">Govt. Share is
                                                                required.</div>
                                                            <div *ngIf="govtShare.errors?.['min']">Must be at least 1.
                                                            </div>
                                                            <div *ngIf="govtShare.errors?.['max']">Cannot be more than
                                                                9,999,999.</div>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6 mb-2">
                                                        <label class="form-label">Redemption of Govt. Share <span
                                                                class="text-danger">*</span></label>
                                                        <input type="number"
                                                            [(ngModel)]="commanPerameter.redemptionGovtShare"
                                                            class="form-control" #redemptionGovtShare="ngModel" required
                                                            min="1" max="9999999"
                                                            placeholder="Enter redemption of Govt. Share"
                                                            [disabled]="isReadOnly" (keypress)="validateNumber($event)">
                                                        <div *ngIf="redemptionGovtShare.invalid && redemptionGovtShare.touched"
                                                            class="text-danger">
                                                            <div *ngIf="redemptionGovtShare.errors?.['required']">
                                                                Redemption
                                                                amount is required.</div>
                                                            <div *ngIf="redemptionGovtShare.errors?.['min']">Must be at
                                                                least 1.</div>
                                                            <div *ngIf="redemptionGovtShare.errors?.['max']">Cannot be
                                                                more
                                                                than 9,999,999.</div>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6 mb-2">
                                                        <label class="form-label">Govt. Dividend Payable <span
                                                                class="text-danger">*</span></label>
                                                        <input type="number"
                                                            [(ngModel)]="commanPerameter.govtDividentPayable"
                                                            class="form-control" #govtDivPayable="ngModel" required
                                                            min="1" max="9999999" [disabled]="isReadOnly"
                                                            placeholder="Enter Govt. Dividend Payable"
                                                            (keypress)="validateNumber($event)">
                                                        <div *ngIf="govtDivPayable.invalid && govtDivPayable.touched"
                                                            class="text-danger">
                                                            <div *ngIf="govtDivPayable.errors?.['required']">Govt.
                                                                Dividend
                                                                Payable is required.</div>
                                                            <div *ngIf="govtDivPayable.errors?.['min']">Must be at least
                                                                1.
                                                            </div>
                                                            <div *ngIf="govtDivPayable.errors?.['max']">Cannot be more
                                                                than
                                                                9,999,999.</div>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6 mb-2">
                                                        <label class="form-label">Govt. Dividend Paid <span
                                                                class="text-danger">*</span></label>
                                                        <input type="number"
                                                            [(ngModel)]="commanPerameter.govtDividentPaid"
                                                            class="form-control" #govtDivPaid="ngModel" required min="0"
                                                            max="999999999999999" [disabled]="isReadOnly"
                                                            placeholder="Govt. Dividend Paid"
                                                            (keypress)="validateNumber($event)">
                                                        <div *ngIf="govtDivPaid.invalid && govtDivPaid.touched"
                                                            class="text-danger">
                                                            <div *ngIf="govtDivPaid.errors?.['required']">Govt. Dividend
                                                                Paid is required.</div>
                                                            <div *ngIf="govtDivPaid.errors?.['min']">Must be at least 1.
                                                            </div>
                                                            <div *ngIf="govtDivPaid.errors?.['max']">Cannot be more than
                                                                999,999,999,999,999.</div>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6 mb-2">
                                                        <label class="form-label">Govt. Loan <span
                                                                class="text-danger">*</span></label>
                                                        <input type="number" [(ngModel)]="commanPerameter.govtLoan"
                                                            class="form-control" #govtLoan="ngModel" required min="1"
                                                            max="9999999" [disabled]="isReadOnly"
                                                            placeholder="Enter Govt. Loan"
                                                            (keypress)="validateNumber($event)">
                                                        <div *ngIf="govtLoan.invalid && govtLoan.touched"
                                                            class="text-danger">
                                                            <div *ngIf="govtLoan.errors?.['required']">Govt. Loan is
                                                                required.</div>
                                                            <div *ngIf="govtLoan.errors?.['min']">Must be at least 1.
                                                            </div>
                                                            <div *ngIf="govtLoan.errors?.['max']">Cannot be more than
                                                                9,999,999.</div>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6 mb-2">
                                                        <label class="form-label">Recovery of Principal and Interest
                                                            <span class="text-danger">*</span></label>
                                                        <input type="number"
                                                            [(ngModel)]="commanPerameter.recoveryOfPrincipalInt"
                                                            class="form-control" #recoveryPrincipal="ngModel" required
                                                            min="1" max="9999999"
                                                            placeholder="Enter Recovery of Principal and Interest"
                                                            (keypress)="validateNumber($event)" [disabled]="isReadOnly">
                                                        <div *ngIf="recoveryPrincipal.invalid && recoveryPrincipal.touched"
                                                            class="text-danger">
                                                            <div *ngIf="recoveryPrincipal.errors?.['required']">Recovery
                                                                of
                                                                Principal and Interest is required.</div>
                                                            <div *ngIf="recoveryPrincipal.errors?.['min']">Must be at
                                                                least
                                                                1.</div>
                                                            <div *ngIf="recoveryPrincipal.errors?.['max']">Cannot be
                                                                more
                                                                than 9,999,999.</div>
                                                        </div>
                                                    </div>

                                                </div> <!-- End of conditional div -->
                                            </div>
                                            <div class="col-md-12 mb-2">
                                                <label class="form-label">Specify any other
                                                    facilities/services/businesses carried out by the PACS
                                                    <sup>(If Any)</sup> <span class="text-danger">*</span>
                                                </label>
                                                <input type="text"
                                                    [(ngModel)]="commanPerameter.specifyFacilitiesService"
                                                    class="form-control" #otherFacilities="ngModel"
                                                    [disabled]="isReadOnly" required
                                                    placeholder="Enter value in this field" minlength="1"
                                                    maxlength="50">
                                                <div *ngIf="otherFacilities.invalid && otherFacilities.touched"
                                                    class="text-danger">
                                                    This field is required.
                                                </div>
                                            </div>

                                            <div class="col-md-12 text-end mt-2">
                                                <button type="button" class="btn btn-primary"
                                                    [disabled]="!commonPerameterFormValid()"
                                                    [style.display]="hasSubmittedRemark ? 'none' : 'inline-block'"
                                                    (click)="submitCommanPerameterForm(); NextButton(currentToggleId4)">Save
                                                    And Continue</button>
                                            </div>
                                        </div>


                                    </div>

                                </div>

                            </div>
                            <div class="accordion-item" *ngIf="isCreditSociety">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseFive" aria-expanded="false"
                                        aria-controls="collapseFive">
                                        Credit Cooperative Societies
                                    </button>
                                </h2>
                                <div id="collapseFive" class="accordion-collapse collapse"
                                    data-bs-parent="#accordianAuditReports">
                                    <div class="accordion-body">

                                        <div class="row align-items-end">

                                            <!-- PACS/ Banks and NATC (Non-agri) Section -->
                                            <!-- <div class="col-md-12">
                                                <h6 class="text-medium">PACS/ Banks and NATC (Non-agri)</h6>
                                            </div> -->

                                            <!-- Loan to Agriculture -->
                                            <div class="col-md-6 mb-2">
                                                <input type="hidden" class="form-control" [disabled]="isReadOnly"
                                                    [(ngModel)]="newcoprateSocity.transId" name="transId"
                                                    placeholder="Enter Type" disabled hidden>
                                                <label class="form-label">Loan to Agriculture(<sup>in year</sup>) <span
                                                        class="text-danger">*</span></label>
                                                <input type="number" [(ngModel)]="newcoprateSocity.sLoanAgriculture"
                                                    [disabled]="isReadOnly" name="loanAgriculture"
                                                    #loanAgriculture="ngModel" placeholder="Enter Loan to Agriculture"
                                                    class="form-control" required min="1" max="999"
                                                    (keypress)="validateNumber($event)">
                                                <div *ngIf="loanAgriculture.touched && loanAgriculture.invalid"
                                                    class="text-danger">
                                                    <div *ngIf="loanAgriculture.errors?.['required']"> Loan Agriculture
                                                        is
                                                        required.
                                                    </div>
                                                    <div *ngIf="loanAgriculture.errors?.['min']">Loan Agriculture must
                                                        be at
                                                        least 1.
                                                    </div>
                                                    <div *ngIf="loanAgriculture.errors?.['max']">Loan Agriculture cannot
                                                        be
                                                        more than
                                                        999</div>
                                                </div>
                                            </div>

                                            <!-- Loan to Non-Agriculture -->
                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">Loan to Non-Agriculture(<sup>in year</sup>)
                                                    <span class="text-danger">*</span></label>
                                                <input type="number" [disabled]="isReadOnly"
                                                    [(ngModel)]="newcoprateSocity.sLoanNonAgriculture"
                                                    name="loanNonAgriculture" #loanNonAgriculture="ngModel"
                                                    placeholder="Enter Loan to Non-Agriculture" class="form-control"
                                                    min="1" required maxlength="999"
                                                    (keypress)="validateNumber($event)">
                                                <div *ngIf="loanNonAgriculture.touched && loanNonAgriculture.invalid"
                                                    class="text-danger">
                                                    <div *ngIf="loanNonAgriculture.errors?.['required']">
                                                        Loan to Non-Agriculture is required.

                                                    </div>
                                                    <div *ngIf="loanNonAgriculture.errors?.['min']">Loan to
                                                        Non-Agriculture
                                                        must be at least 1.
                                                    </div>
                                                    <div *ngIf="loanNonAgriculture.errors?.['max']">Loan to
                                                        Non-Agriculture
                                                        cannot be more than
                                                        999</div>
                                                </div>
                                            </div>

                                            <!-- Loan Distribution Section -->
                                            <div class="col-md-12">
                                                <h6 class="text-medium">Loan Distribution</h6>
                                            </div>

                                            <!-- Short Term -->
                                            <div class="col-md-4 mb-2">
                                                <label class="form-label">Short Term(<sup>in year</sup>) <span
                                                        class="text-danger">*</span></label>
                                                <input type="number" [disabled]="isReadOnly"
                                                    [(ngModel)]="newcoprateSocity.sLoanDistributionShort"
                                                    name="loanDistributionShort" #loanDistributionShort="ngModel"
                                                    placeholder="Enter Short Term" class="form-control" required min="1"
                                                    max="999" (keypress)="validateNumber($event)">
                                                <div *ngIf="loanDistributionShort.touched && loanDistributionShort.invalid"
                                                    class="text-danger">
                                                    <div *ngIf="loanDistributionShort.errors?.['required']">
                                                        Short Term is required.

                                                    </div>
                                                    <div *ngIf="loanDistributionShort.errors?.['min']">Short Term must
                                                        be at
                                                        least 1.
                                                    </div>
                                                    <div *ngIf="loanDistributionShort.errors?.['max']">Short Term cannot
                                                        be
                                                        more than
                                                        999</div>

                                                </div>
                                            </div>

                                            <!-- Medium Term -->
                                            <div class="col-md-4 mb-2">
                                                <label class="form-label">Medium Term (<sup>in year</sup>)<span
                                                        class="text-danger">*</span></label>
                                                <input type="number" [disabled]="isReadOnly"
                                                    [(ngModel)]="newcoprateSocity.sLoanDistributionMedium"
                                                    name="loanDistributionMedium" #loanDistributionMedium="ngModel"
                                                    placeholder="Enter Medium Term" class="form-control" required
                                                    min="1" max="999" (keypress)="validateNumber($event)">
                                                <div *ngIf="loanDistributionMedium.touched && loanDistributionMedium.invalid"
                                                    class="text-danger">
                                                    <div *ngIf="loanDistributionMedium.errors?.['required']">
                                                        Medium Term is required.

                                                    </div>
                                                    <div *ngIf="loanDistributionMedium.errors?.['min']">Medium Term must
                                                        be
                                                        at least 1.
                                                    </div>
                                                    <div *ngIf="loanDistributionMedium.errors?.['max']">Medium Term
                                                        cannot
                                                        be more than
                                                        999</div>

                                                </div>
                                            </div>

                                            <!-- Long Term -->
                                            <div class="col-md-4 mb-2">
                                                <label class="form-label">Long Term(<sup>in year</sup>) <span
                                                        class="text-danger">*</span></label>
                                                <input type="number" [disabled]="isReadOnly"
                                                    [(ngModel)]="newcoprateSocity.sLoanDistributionLong"
                                                    name="loanDistributionLong" #loanDistributionLong="ngModel"
                                                    placeholder="Enter Long Term" class="form-control" required min="1"
                                                    max="9999" (keypress)="validateNumber($event)">
                                                <div *ngIf="loanDistributionLong.touched && loanDistributionLong.invalid"
                                                    class="text-danger">
                                                    <div *ngIf="loanDistributionLong.errors?.['required']">
                                                        Long Term is required.

                                                    </div>
                                                    <div *ngIf="loanDistributionLong.errors?.['min']">Long Term must be
                                                        at
                                                        least 1.
                                                    </div>
                                                    <div *ngIf="loanDistributionLong.errors?.['max']">Long Term cannot
                                                        be
                                                        more than
                                                        999</div>

                                                </div>
                                            </div>

                                            <!-- Loan Recovery Section -->
                                            <div class="col-md-12">
                                                <h6 class="text-medium">Loan Recovery</h6>
                                            </div>

                                            <!-- Short Term -->
                                            <div class="col-md-4 mb-2">
                                                <label class="form-label">Short Term(<sup>in year</sup>) <span
                                                        class="text-danger">*</span></label>
                                                <input type="number" [disabled]="isReadOnly"
                                                    [(ngModel)]="newcoprateSocity.sLoanRecoveryShort"
                                                    name="loanRecoveryShort" #loanRecoveryShort="ngModel"
                                                    placeholder="Enter Short Term" class="form-control" required min="1"
                                                    max="999" (keypress)="validateNumber($event)">
                                                <div *ngIf="loanRecoveryShort.touched && loanRecoveryShort.invalid"
                                                    class="text-danger">
                                                    <div *ngIf="loanRecoveryShort.errors?.['required']">
                                                        Short Term is required.

                                                    </div>
                                                    <div *ngIf="loanRecoveryShort.errors?.['min']">Short Term must be at
                                                        least 1.
                                                    </div>
                                                    <div *ngIf="loanRecoveryShort.errors?.['max']">Short Term cannot be
                                                        more
                                                        than
                                                        999</div>

                                                </div>
                                            </div>

                                            <!-- Medium Term -->
                                            <div class="col-md-4 mb-2">
                                                <label class="form-label">Medium Term(<sup>in year</sup>) <span
                                                        class="text-danger">*</span></label>
                                                <input type="number" [disabled]="isReadOnly"
                                                    [(ngModel)]="newcoprateSocity.sLoanRecoveryMedium"
                                                    name="loanRecoveryMedium" #loanRecoveryMedium="ngModel"
                                                    placeholder="Enter Medium Term" class="form-control" required
                                                    min="1" max="999" (keypress)="validateNumber($event)">
                                                <div *ngIf="loanRecoveryMedium.touched && loanRecoveryMedium.invalid"
                                                    class="text-danger">

                                                    <div *ngIf="loanRecoveryMedium.errors?.['required']">
                                                        Medium Term is required.

                                                    </div>
                                                    <div *ngIf="loanRecoveryMedium.errors?.['min']">Medium Term must be
                                                        at
                                                        least 1.
                                                    </div>
                                                    <div *ngIf="loanRecoveryMedium.errors?.['max']">Medium Term cannot
                                                        be
                                                        more than
                                                        999</div>

                                                </div>
                                            </div>

                                            <!-- Long Term -->
                                            <div class="col-md-4 mb-2">
                                                <label class="form-label">Long Term (<sup>in year</sup>)<span
                                                        class="text-danger">*</span></label>
                                                <input type="number" [disabled]="isReadOnly"
                                                    [(ngModel)]="newcoprateSocity.sLoanRecoveryLong"
                                                    name="loanRecoveryLong" #loanRecoveryLong="ngModel"
                                                    placeholder="Enter Long Term" class="form-control" required min="1"
                                                    max="999" (keypress)="validateNumber($event)">
                                                <div *ngIf="loanRecoveryLong.touched && loanRecoveryLong.invalid"
                                                    class="text-danger">
                                                    <div *ngIf="loanRecoveryLong.errors?.['required']">
                                                        Long Term is required.

                                                    </div>
                                                    <div *ngIf="loanRecoveryLong.errors?.['min']">Long Term must be at
                                                        least
                                                        1.
                                                    </div>
                                                    <div *ngIf="loanRecoveryLong.errors?.['max']">Long Term cannot be
                                                        more
                                                        than
                                                        999</div>

                                                </div>
                                            </div>

                                            <!-- Loan Outstanding Section -->
                                            <div class="col-md-12">
                                                <h6 class="text-medium">Loan Outstanding</h6>
                                            </div>

                                            <!-- Short Term -->
                                            <div class="col-md-4 mb-2">
                                                <label class="form-label">Short Term(<sup>in year</sup>) <span
                                                        class="text-danger">*</span></label>
                                                <input type="number" [disabled]="isReadOnly"
                                                    [(ngModel)]="newcoprateSocity.sLoanOutstandingShort"
                                                    name="loanOutstandingShort" #loanOutstandingShort="ngModel"
                                                    placeholder="Enter Short Term" class="form-control" required min="1"
                                                    max="999" (keypress)="validateNumber($event)">
                                                <div *ngIf="loanOutstandingShort.touched && loanOutstandingShort.invalid"
                                                    class="text-danger">
                                                    <div *ngIf="loanOutstandingShort.errors?.['required']">
                                                        Short Term is required.

                                                    </div>
                                                    <div *ngIf="loanOutstandingShort.errors?.['min']">Short Term must be
                                                        at
                                                        least 1.
                                                    </div>
                                                    <div *ngIf="loanOutstandingShort.errors?.['max']">Short Term cannot
                                                        be
                                                        more than
                                                        999</div>

                                                </div>
                                            </div>

                                            <!-- Medium Term -->
                                            <div class="col-md-4 mb-2">
                                                <label class="form-label">Medium Term (<sup>in year</sup>)<span
                                                        class="text-danger">*</span></label>
                                                <input type="number" [disabled]="isReadOnly"
                                                    [(ngModel)]="newcoprateSocity.sLoanOutstandingMedium"
                                                    name="loanOutstandingMedium" #loanOutstandingMedium="ngModel"
                                                    placeholder="Enter Medium Term" class="form-control" required
                                                    min="1" max="999" (keypress)="validateNumber($event)">
                                                <div *ngIf="loanOutstandingMedium.touched && loanOutstandingMedium.invalid"
                                                    class="text-danger">

                                                    <div *ngIf="loanOutstandingMedium.errors?.['required']">
                                                        Medium Term is required.

                                                    </div>
                                                    <div *ngIf="loanOutstandingMedium.errors?.['min']">Medium Term must
                                                        be
                                                        at least 1.
                                                    </div>
                                                    <div *ngIf="loanOutstandingMedium.errors?.['max']">Medium Term
                                                        cannot be
                                                        more than
                                                        999</div>

                                                </div>
                                            </div>

                                            <!-- Long Term -->
                                            <div class="col-md-4 mb-2">
                                                <label class="form-label">Long Term (<sup>in year</sup>)<span
                                                        class="text-danger">*</span></label>
                                                <input type="number" [disabled]="isReadOnly"
                                                    [(ngModel)]="newcoprateSocity.sLoanOutstandingLong"
                                                    name="loanOutstandingLong" #loanOutstandingLong="ngModel"
                                                    placeholder="Enter Long Term" class="form-control" required min="1"
                                                    max="999" (keypress)="validateNumber($event)">
                                                <div *ngIf="loanOutstandingLong.touched && loanOutstandingLong.invalid"
                                                    class="text-danger">

                                                    <div *ngIf="loanOutstandingLong.errors?.['required']">
                                                        Long Term is required.

                                                    </div>
                                                    <div *ngIf="loanOutstandingLong.errors?.['min']">Long Term must be
                                                        at
                                                        least 1.
                                                    </div>
                                                    <div *ngIf="loanOutstandingLong.errors?.['max']">Long Term cannot be
                                                        more than
                                                        999</div>

                                                </div>
                                            </div>

                                            <!-- Loan Overdue Section -->
                                            <div class="col-md-12">
                                                <h6 class="text-medium">Loan Overdue</h6>
                                            </div>

                                            <!-- Short Term -->
                                            <div class="col-md-4 mb-2">
                                                <label class="form-label">Short Term(<sup>in year</sup>) <span
                                                        class="text-danger">*</span></label>
                                                <input type="number" [disabled]="isReadOnly"
                                                    [(ngModel)]="newcoprateSocity.sLoanOverdueShort"
                                                    name="loanOverdueShort" #loanOverdueShort="ngModel"
                                                    placeholder="Enter Short Term" class="form-control" required min="1"
                                                    max="999" (keypress)="validateNumber($event)">
                                                <div *ngIf="loanOverdueShort.touched && loanOverdueShort.invalid"
                                                    class="text-danger">

                                                    <div *ngIf="loanOverdueShort.errors?.['required']">
                                                        Short Term is required.

                                                    </div>
                                                    <div *ngIf="loanOverdueShort.errors?.['min']">Short Term must be at
                                                        least 1.
                                                    </div>
                                                    <div *ngIf="loanOverdueShort.errors?.['max']">Short Term cannot be
                                                        more
                                                        than
                                                        999</div>

                                                </div>
                                            </div>

                                            <!-- Medium Term -->
                                            <div class="col-md-4 mb-2">
                                                <label class="form-label">Medium Term(<sup>in year</sup>) <span
                                                        class="text-danger">*</span></label>
                                                <input type="number" [disabled]="isReadOnly"
                                                    [(ngModel)]="newcoprateSocity.sLoanOverdueMedium"
                                                    name="loanOverdueMedium" #loanOverdueMedium="ngModel"
                                                    placeholder="Enter Medium Term" class="form-control" required
                                                    min="1" max="999" (keypress)="validateNumber($event)">
                                                <div *ngIf="loanOverdueMedium.touched && loanOverdueMedium.invalid"
                                                    class="text-danger">

                                                    <div *ngIf="loanOverdueMedium.errors?.['required']">
                                                        Medium Term is required.

                                                    </div>
                                                    <div *ngIf="loanOverdueMedium.errors?.['min']">Medium Term must be
                                                        at
                                                        least 1.
                                                    </div>
                                                    <div *ngIf="loanOverdueMedium.errors?.['max']">Medium Term cannot be
                                                        more than
                                                        999</div>

                                                </div>
                                            </div>

                                            <!-- Long Term -->
                                            <div class="col-md-4 mb-2">
                                                <label class="form-label">Long Term(<sup>in year</sup>) <span
                                                        class="text-danger">*</span></label>
                                                <input type="number" [disabled]="isReadOnly"
                                                    [(ngModel)]="newcoprateSocity.sLoanOverdueLong"
                                                    name="loanOverdueLong" #loanOverdueLong="ngModel"
                                                    placeholder="Enter Long Term" class="form-control" required
                                                    max="999" min="1" (keypress)="validateNumber($event)">
                                                <div *ngIf="loanOverdueLong.touched && loanOverdueLong.invalid"
                                                    class="text-danger">

                                                    <div *ngIf="loanOverdueLong.errors?.['required']">
                                                        Long Term is required.

                                                    </div>
                                                    <div *ngIf="loanOverdueLong.errors?.['min']">Long Term must be at
                                                        least
                                                        1.
                                                    </div>
                                                    <div *ngIf="loanOverdueLong.errors?.['max']">Long Term cannot be
                                                        more
                                                        than
                                                        999</div>

                                                </div>
                                            </div>





                                            <div class="col-md-12">
                                                <h6 class="text-medium">Borrowers Details</h6>
                                            </div>

                                            <form #formBorr="ngForm" (ngSubmit)="submitBorrowersForm(formBorr)">
                                                <!-- Category Select Field -->
                                                <div class="row">
                                                    <div class="col-md-4 mb-2">
                                                        <input type="hidden" class="form-control"
                                                            [(ngModel)]="borrower.iSocietyCreditCoOperativeID"
                                                            name="iSocietyCreditCoOperativeID" placeholder="Enter Type"
                                                            disabled hidden>
                                                        <input type="hidden" class="form-control"
                                                            [disabled]="isReadOnly" [(ngModel)]="borrower.transId"
                                                            name="transId" placeholder="Enter Type" disabled hidden>
                                                        <label class="form-label">Category <span
                                                                class="text-danger">*</span></label>
                                                        <select class="form-control"
                                                            [(ngModel)]="borrower.sCasteCategory" id="sCasteCategory"
                                                            name="sCasteCategory" required #sCasteCategory="ngModel"
                                                            [disabled]="isReadOnly">
                                                            <option value="" selected>Select Category</option>
                                                            <option *ngFor="let cat of category" [value]="cat.name">{{
                                                                cat.name }}</option>
                                                        </select>
                                                        <div *ngIf="sCasteCategory.touched && sCasteCategory.invalid"
                                                            class="text-danger">
                                                            Caste Category is required.
                                                        </div>
                                                    </div>

                                                    <!-- Defaulter Name Input Field -->
                                                    <div class="col-md-4 mb-2">
                                                        <label class="form-label">No. of Defaulters<span
                                                                class="text-danger">*</span></label>
                                                        <input type="number" class="form-control"
                                                            [(ngModel)]="borrower.sDefaulterName"
                                                            placeholder="Defaulter No." name="sDefaulterName"
                                                            [disabled]="isReadOnly" id="sDefaulterName" min="1"
                                                            max="999" (keypress)="validateNumber($event)" required
                                                            #sDefaulterName="ngModel">
                                                        <div *ngIf="sDefaulterName.touched && sDefaulterName.invalid"
                                                            class="text-danger">
                                                            <div *ngIf="sDefaulterName.errors?.['required']">
                                                                Defaulter no. is required.

                                                            </div>
                                                            <div *ngIf="sDefaulterName.errors?.['min']">Defaulter no.
                                                                must
                                                                be at least 1.
                                                            </div>
                                                            <div *ngIf="sDefaulterName.errors?.['max']">Defaulter no.
                                                                cannot
                                                                be more than
                                                                999</div>

                                                        </div>
                                                    </div>

                                                    <!-- Amount Input Field -->
                                                    <div class="col-md-4 mb-2">
                                                        <label class="form-label">Amount <span
                                                                class="text-danger">*</span></label>

                                                        <input type="number" class="form-control"
                                                            [(ngModel)]="borrower.sAmount" placeholder="Enter Amount"
                                                            [disabled]="isReadOnly" name="sAmount" id="sAmount" min="1"
                                                            max="9999999" (keypress)="validateNumber($event)" required
                                                            #sAmountControl="ngModel">

                                                        <!-- Validation Messages -->
                                                        <div *ngIf="sAmountControl.invalid && sAmountControl.touched"
                                                            class="text-danger">
                                                            <div *ngIf="sAmountControl.errors?.['required']">
                                                                Amount is required.

                                                            </div>
                                                            <div *ngIf="sAmountControl.errors?.['min']">Amount must be
                                                                at
                                                                least 1.
                                                            </div>
                                                            <div *ngIf="sAmountControl.errors?.['max']">Amount cannot be
                                                                more than
                                                                9999999</div>

                                                        </div>
                                                    </div>


                                                    <!-- Submit Button -->
                                                    <div class="col-md-12 mb-3 text-end">
                                                        <input type="submit" class="btn btn-outline-primary btn-sm"
                                                            [style.display]="hasSubmittedRemark ? 'none' : 'inline-block'"
                                                            value="Add">
                                                    </div>
                                                </div>
                                            </form>

                                            <div class="col-md-12">

                                                <ngx-datatable
                                                    class="ngx-datatable billdata colored-header sm table-striped table-hover"
                                                    [rows]="Borrowerdatas" [columns]="cols" [columnMode]="'force'"
                                                    [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
                                                    [externalPaging]="true" [count]="page.totalRecords"
                                                    [offset]="page.pageNumber" [limit]="page.pageSize"
                                                    (page)="getBorrowerList()" [virtualization]="false"
                                                    [scrollbarV]="false" [scrollbarH]="true"
                                                    [loadingIndicator]="loading">

                                                    <!-- S.No. Column -->
                                                    <ngx-datatable-column name="#" [sortable]="false" [width]="50">
                                                        <ng-template let-rowIndex="rowIndex"
                                                            ngx-datatable-cell-template>
                                                            <span>{{ (page.pageNumber * page.pageSize) + rowIndex + 1
                                                                }}</span>
                                                        </ng-template>
                                                    </ngx-datatable-column>

                                                    <!-- Dynamic Columns -->
                                                    <ngx-datatable-column *ngFor="let col of cols" [name]="col.name"
                                                        [prop]="col.prop" [sortable]="true">
                                                        <ng-template ngx-datatable-cell-template let-row="row"
                                                            let-value="value">
                                                            {{ value }}
                                                        </ng-template>
                                                    </ngx-datatable-column>

                                                    <!-- Action Column -->
                                                    <ngx-datatable-column name="Action" [sortable]="false"
                                                        [width]="100">
                                                        <ng-template let-row="row" ngx-datatable-cell-template>
                                                            <button type="button" class="btn btn-danger btn-sm"
                                                                (click)="openDeleteModal(0, 0, row.iSocietyBorrowerDetails, 'Borrower')"
                                                                data-bs-toggle="modal"
                                                                data-bs-target="#exampleModalCenter"
                                                                [disabled]="isDeleteDisabled">
                                                                <i class="bi bi-trash3"></i>
                                                            </button>
                                                        </ng-template>
                                                    </ngx-datatable-column>

                                                </ngx-datatable>


                                            </div>

                                            <div class="col-md-12 text-end mt-2">
                                                <button type="button" class="btn btn-primary"
                                                    [disabled]="!coprateSocietyFormValid()"
                                                    [style.display]="hasSubmittedRemark ? 'none' : 'inline-block'"
                                                    (click)="submitCoprateSocietyForm(); NextButton(currentToggleId5)">Save
                                                    And Continue</button>
                                            </div>


                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                        Non - Credit Cooperative Societies
                                    </button>
                                </h2>
                                <div id="collapseSix" class="accordion-collapse collapse"
                                    data-bs-parent="#accordianAuditReports">
                                    <div class="accordion-body">

                                        <form #trainingForm="ngForm" (ngSubmit)="submitNonCreditForm()" novalidate>
                                            <div class="row align-items-end">
                                                <input type="hidden" class="form-control" [disabled]="isReadOnly"
                                                    [(ngModel)]="newnonCredit.transId" name="transId"
                                                    placeholder="Enter Type" disabled hidden>
                                                <div class="col-md-12">
                                                    <h6 class="text-medium">
                                                        Educational and Training Cooperative/ Apex HIMCOFED/ HIMCAPES
                                                        <span class="text-danger">*</span>
                                                    </h6>
                                                </div>

                                                <div class="col-md-6 mb-2">
                                                    <label class="form-label">
                                                        No of Training Conducted <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="number" id="trainingNo" name="trainingNo"
                                                        [disabled]="isReadOnly" [(ngModel)]="newnonCredit.sTrainingNo"
                                                        placeholder="No of Training Conducted" class="form-control"
                                                        required maxlength="15" (keypress)="validateNumber($event)" />
                                                    <div *ngIf="trainingForm.submitted && !newnonCredit.sTrainingNo"
                                                        class="invalid-feedback">
                                                        Please enter the number of training conducted.
                                                    </div>
                                                </div>

                                                <div class="col-md-6 mb-2">
                                                    <label class="form-label">
                                                        Specific Training Areas (<sup>for financial year</sup>)<span
                                                            class="text-danger">*</span>
                                                    </label>
                                                    <input type="number" id="specificTrainingArea"
                                                        name="specificTrainingArea" [disabled]="isReadOnly"
                                                        [(ngModel)]="newnonCredit.sSpecificAuditYearArea"
                                                        placeholder="Specific Training Areas" class="form-control"
                                                        required maxlength="15" (keypress)="validateNumber($event)" />
                                                    <div *ngIf="trainingForm.submitted && !newnonCredit.sSpecificAuditYearArea"
                                                        class="invalid-feedback">
                                                        Please enter the specific training areas for the financial year.
                                                    </div>
                                                </div>

                                                <div class="col-md-6 mb-2">
                                                    <label class="form-label">
                                                        No of Trained Professionals <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="number" id="trainedProfessionals"
                                                        name="trainedProfessionals" [disabled]="isReadOnly"
                                                        [(ngModel)]="newnonCredit.sNoTrainedConducted"
                                                        placeholder="No of Trained Professionals" class="form-control"
                                                        required maxlength="15" (keypress)="validateNumber($event)" />
                                                    <div *ngIf="trainingForm.submitted && !newnonCredit.sNoTrainedConducted"
                                                        class="invalid-feedback">
                                                        Please enter the number of trained professionals.
                                                    </div>
                                                </div>

                                                <div class="col-md-12">
                                                    <h6 class="text-medium">Number of Workers</h6>
                                                </div>

                                                <div class="col-md-6 mb-2">
                                                    <label class="form-label">
                                                        Teaching Staff <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="text" id="teachingStaff" name="teachingStaff"
                                                        [disabled]="isReadOnly"
                                                        [(ngModel)]="newnonCredit.sNoTeachingWorkers"
                                                        placeholder="Enter Teaching Staff" class="form-control"
                                                        required />
                                                    <div *ngIf="trainingForm.submitted && !newnonCredit.sNoTeachingWorkers"
                                                        class="invalid-feedback">
                                                        Please enter the number of teaching staff.
                                                    </div>
                                                </div>

                                                <div class="col-md-6 mb-2">
                                                    <label class="form-label">
                                                        Other Staff <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="text" id="otherStaff" name="otherStaff"
                                                        [disabled]="isReadOnly" [(ngModel)]="newnonCredit.sNoOtherStaff"
                                                        placeholder="Enter Other Staff" class="form-control" required />
                                                    <div *ngIf="trainingForm.submitted && !newnonCredit.sNoOtherStaff"
                                                        class="invalid-feedback">
                                                        Please enter the number of other staff.
                                                    </div>
                                                </div>

                                                <div class="text-end">
                                                    <button type="submit" class="btn btn-primary"
                                                        [disabled]="!nonCreditFormValid()"
                                                        [style.display]="hasSubmittedRemark ? 'none' : 'inline-block'"
                                                        (click)="submitNonCreditForm(); NextButton(currentToggleId6)">Save
                                                        And Continue</button>
                                                </div>
                                            </div>
                                        </form>



                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseSeven" aria-expanded="false"
                                        aria-controls="collapseSeven">
                                        Audit Parameters
                                    </button>
                                </h2>
                                <div id="collapseSeven" class="accordion-collapse collapse"
                                    data-bs-parent="#accordianAuditReports">
                                    <div class="accordion-body">

                                        <div class="row align-items-end">
                                            <input type="hidden" class="form-control" [disabled]="isReadOnly"
                                                [(ngModel)]="newAuditPera.transid" name="transid"
                                                placeholder="Enter Type" disabled hidden>
                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">
                                                    Total outstanding loan extended to members in last financial
                                                    year (<sup>in Rs</sup>) <span class="text-danger">*</span>
                                                </label>
                                                <input type="number" id="sTotalOutStanding" name="sTotalOutStanding"
                                                    [disabled]="isReadOnly" [(ngModel)]="newAuditPera.sTotalOutStanding"
                                                    placeholder="Enter Total outstanding loan" class="form-control"
                                                    required min="1" max="9999999" (keypress)="validateNumber($event)"
                                                    #outstanding="ngModel" />
                                                <div *ngIf="outstanding.touched && !newAuditPera.sTotalOutStanding"
                                                    class="text-danger">


                                                    <div *ngIf="outstanding.errors?.['required']"> Total outstanding
                                                        loan is
                                                        required.</div>
                                                    <div *ngIf="outstanding.errors?.['min']">Total outstanding loan must
                                                        be at least 100.
                                                    </div>
                                                    <div *ngIf="outstanding.errors?.['max']">Total outstanding loan
                                                        cannot be more than
                                                        9,999,999.</div>
                                                </div>
                                            </div>

                                            <div class="col-md-6 mb-2">
                                                <label class="form-label">
                                                    Last financial revenue (other than interest) from non-credit
                                                    activities (<sup>in Rs</sup>) <span class="text-danger">*</span>
                                                </label>
                                                <input type="number" id="specificTrainingArea"
                                                    name="specificTrainingArea" [disabled]="isReadOnly"
                                                    [(ngModel)]="newAuditPera.sSpecificTrainingArea"
                                                    placeholder="Enter Last financial revenue" class="form-control"
                                                    required min="1" max="9999999" (keypress)="validateNumber($event)"
                                                    #sSpecificTrainingArea="ngModel" />
                                                <div *ngIf="sSpecificTrainingArea.touched && !newAuditPera.sSpecificTrainingArea"
                                                    class="text-danger">

                                                    <div *ngIf="outstanding.errors?.['required']">
                                                        Last financial revenue is required.</div>
                                                    <div *ngIf="outstanding.errors?.['min']"> Last financial revenue
                                                        must be at least 100.
                                                    </div>
                                                    <div *ngIf="outstanding.errors?.['max']"> Last financial revenue
                                                        cannot be more than
                                                        9,999,999.</div>

                                                </div>
                                            </div>

                                            <div class="col-md-12">
                                                <h6 class="mt-2 text-medium">Balance Sheet</h6>
                                            </div>

                                            <form #form="ngForm" (ngSubmit)="submitBalanceForm(form)">
                                                <div class="row">
                                                    <div class="col-md-6 mb-3">
                                                        <input type="hidden" class="form-control"
                                                            [(ngModel)]="newBalance.transId" name="transId">
                                                        <input type="hidden" class="form-control"
                                                            [(ngModel)]="newBalance.iSocietyCommonParameterID"
                                                            name="iSocietyCommonParameterID">

                                                        <select class="form-control" [disabled]="isReadOnly"
                                                            [(ngModel)]="newBalance.type" id="type" name="type" required
                                                            #typeControl="ngModel">
                                                            <option value="" selected>Select Type</option>
                                                            <option *ngFor="let bal of balanceSheet" [value]="bal.name">
                                                                {{ bal.name }}
                                                            </option>
                                                        </select>
                                                        <div *ngIf="typeControl.invalid && typeControl.touched"
                                                            class="text-danger">
                                                            Balance Type is required.
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6 mb-3">
                                                        <select class="form-control" [disabled]="isReadOnly"
                                                            [(ngModel)]="newBalance.sParameterType" id="sParameterType"
                                                            name="sParameterType" required
                                                            #sParameterTypeControl="ngModel">
                                                            <option value="" selected>Select Parameter</option>
                                                            <option *ngFor="let per of bsParameter" [value]="per.name">
                                                                {{ per.name }}
                                                            </option>
                                                        </select>
                                                        <div *ngIf="sParameterTypeControl.invalid && sParameterTypeControl.touched"
                                                            class="text-danger">
                                                            Parameter Type is required.
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6 mb-3">
                                                        <input type="number" class="form-control"
                                                            [disabled]="isReadOnly" [(ngModel)]="newBalance.sAmount"
                                                            placeholder="Amount" name="sAmount" id="sAmount" required
                                                            #sAmountControl="ngModel" min="1" max="9999999"
                                                            (keypress)="validateNumber($event)">
                                                        <div *ngIf="sAmountControl.invalid && sAmountControl.touched"
                                                            class="text-danger">

                                                            <div *ngIf="sAmountControl.errors?.['required']">
                                                                Amount is required.</div>
                                                            <div *ngIf="sAmountControl.errors?.['min']"> Amount be at
                                                                least 1.
                                                            </div>
                                                            <div *ngIf="sAmountControl.errors?.['max']"> Amount cannot
                                                                be more than
                                                                9,999,999.</div>


                                                        </div>
                                                    </div>


                                                    <div *ngIf="newBalance.sParameterType === 'Other '"
                                                        class="col-md-6 mb-3">

                                                        <input type="text" class="form-control" [disabled]="isReadOnly"
                                                            [(ngModel)]="newBalance.OtherParameter"
                                                            placeholder="Other Parameter Value" name="OtherParameter"
                                                            id="OtherParameter" minlength="3" maxlength="20">
                                                    </div>


                                                    <div class="col-md-12 mb-3 text-end">
                                                        <input type="submit" class="btn btn-outline-primary btn-sm"
                                                            [style.display]="hasSubmittedRemark ? 'none' : 'inline-block'"
                                                            value="Add">
                                                    </div>
                                                </div>
                                            </form>
                                            <div class="row">
                                                <!-- Liabilities Table -->
                                                <div class="col-lg-6 mt-3">
                                                    <ngx-datatable
                                                        class="ngx-datatable billdata colored-header sm table-striped table-hover"
                                                        [rows]="rowsesLiabilities" [columnMode]="'force'"
                                                        [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
                                                        [externalPaging]="true" [count]="rowsesLiabilities.length"
                                                        [limit]="10" [virtualization]="false" [scrollbarV]="false"
                                                        [scrollbarH]="true" [loadingIndicator]="loading">

                                                        <ngx-datatable-column name="#" [sortable]="false">
                                                            <ng-template ngx-datatable-cell-template
                                                                let-rowIndex="rowIndex">
                                                                <span>{{ rowIndex + 1 }}</span>
                                                            </ng-template>
                                                        </ngx-datatable-column>

                                                        <ngx-datatable-column name="Liabilities" [sortable]="true">
                                                            <ng-template ngx-datatable-cell-template let-row="row">
                                                                <span>{{ row.sParameterType }}</span>
                                                            </ng-template>
                                                        </ngx-datatable-column>

                                                        <ngx-datatable-column name="Amount" [sortable]="true">
                                                            <ng-template ngx-datatable-cell-template let-row="row">
                                                                <span>{{ row.sAmount }}</span>
                                                            </ng-template>
                                                        </ngx-datatable-column>
                                                    </ngx-datatable>
                                                </div>

                                                <!-- Assets Table -->
                                                <div class="col-lg-6 mt-3">
                                                    <ngx-datatable
                                                        class="ngx-datatable billdata colored-header sm table-striped table-hover"
                                                        [rows]="rowsAssets" [columnMode]="'force'" [headerHeight]="50"
                                                        [footerHeight]="50" rowHeight="auto" [externalPaging]="true"
                                                        [count]="rowsAssets.length" [limit]="10"
                                                        [virtualization]="false" [scrollbarV]="false"
                                                        [scrollbarH]="true" [loadingIndicator]="loading">

                                                        <ngx-datatable-column name="#" [sortable]="false">
                                                            <ng-template ngx-datatable-cell-template
                                                                let-rowIndex="rowIndex">
                                                                <span>{{ rowIndex + 1 }}</span>
                                                            </ng-template>
                                                        </ngx-datatable-column>

                                                        <ngx-datatable-column name="Assets" [sortable]="true">
                                                            <ng-template ngx-datatable-cell-template let-row="row">
                                                                <span>{{ row.sParameterType }}</span>
                                                            </ng-template>
                                                        </ngx-datatable-column>

                                                        <ngx-datatable-column name="Amount" [sortable]="true">
                                                            <ng-template ngx-datatable-cell-template let-row="row">
                                                                <span>{{ row.sAmount }}</span>
                                                            </ng-template>
                                                        </ngx-datatable-column>
                                                    </ngx-datatable>
                                                </div>
                                            </div>

                                            <div class="text-end" style="margin-top: 10px;">

                                                <button type="submit" class="btn btn-primary"
                                                    [disabled]="!AuditFormValid()"
                                                    [style.display]="hasSubmittedRemark ? 'none' : 'inline-block'"
                                                    (click)="submitAuditPeraForm(); NextButton(currentToggleId6)">Save
                                                    And Continue</button>
                                            </div>
                                        </div>




                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="my-3">
                            <!-- Hidden Input for Transaction ID -->
                            <input type="hidden" class="form-control" [(ngModel)]="remark.transId" name="transId"
                                disabled>

                            <!-- Remark Label -->
                            <label class="form-label">Remark<span class="text-danger">*</span></label>

                            <!-- Remark Textarea with Validation -->
                            <textarea class="form-control" rows="3" [(ngModel)]="remark.remarks" name="remark"
                                placeholder="Enter Remark Here..." [disabled]="isReadOnly" #remarkInput="ngModel"
                                required>
                            </textarea>

                            <!-- Validation Message -->
                            <div *ngIf="remarkInput.invalid && remarkInput.touched" class="text-danger">
                                Remark is required.
                            </div>
                        </div>


                        <div class="text-end">
                            <button type="submit" class="btn btn-primary"
                                [disabled]="!remarksValid() || hasSubmittedRemark" data-bs-toggle="modal"
                                data-bs-target="#submitModalCenter">Save</button>
                        </div>

                    </div>
                </div>
            </div>
        </div>


    </div>
    <!-- Delete Confirmation Modal -->
    <div class="modal fade" id="exampleModalCenter" tabindex="-1" aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalCenterTitle">Delete Audit</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    {{ confirmationMessage }}
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                        (click)="confirmDelete()">Delete</button>

                </div>
            </div>
        </div>
    </div>
    <!-- Submit Modal -->
    <div class="modal fade" id="submitModalCenter" tabindex="-1" aria-labelledby="submitModalCenterTitle"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="submitModalCenterTitle">Final Submit</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p class="text-danger"><strong>Note:</strong></p> Once you submit this form, you will not be able to
                    edit this checklist Data!
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-danger" data-bs-dismiss="modal"
                        (click)="updateRemark()">Submit</button>

                </div>
            </div>
        </div>
    </div>
</div>